import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import ModalDrawer from "components/source/shared/modal-drawer/modal-drawer";
import QualityIssues from "./quality-issues";

const FeedbackModal = ({ isOpen, currentSurveyIndex, closeFeedbackScreen, feedBackType }) => {
  if (!isOpen || !feedBackType) return null;

  const { isMobileViewport: isMobile } = useSelector(state => state.browser ?? {});

  let modalContent = null;
  switch (feedBackType) {
    case "quality-issues":
      modalContent = (
        <QualityIssues currentSurveyIndex={currentSurveyIndex} closeFeedbackScreen={closeFeedbackScreen} />
      );
      break;
    default:
      modalContent = null;
  }

  if (isMobile) {
    return (
      <ModalDrawer
        isOpen={isOpen}
        peekHeight="80vh"
        handleClose={closeFeedbackScreen}
        isCloseHidden={true}
        hideDragHandle={true}>
        {modalContent}
      </ModalDrawer>
    );
  }

  return <div className="absolute top-0 left-0 w-full h-full bg-white">{modalContent}</div>;
};

FeedbackModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  currentSurveyIndex: PropTypes.number.isRequired,
  closeFeedbackScreen: PropTypes.func.isRequired,
  feedBackType: PropTypes.string.isRequired,
};

export default FeedbackModal;
